import { render, staticRenderFns } from "./productlist.vue?vue&type=template&id=4c2e0879&scoped=true&"
import script from "./productlist.vue?vue&type=script&lang=js&"
export * from "./productlist.vue?vue&type=script&lang=js&"
import style0 from "./productlist.vue?vue&type=style&index=0&id=4c2e0879&lang=scss&scoped=true&"
import style1 from "./productlist.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2e0879",
  null
  
)

export default component.exports